var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37537 6.97366C5.8458 8.83345 10.1806 12.1054 11.4547 13.1256C11.6257 13.2633 11.8092 13.3333 11.9996 13.3333C12.1897 13.3333 12.3728 13.2639 12.5434 13.1269C13.8186 12.1057 18.1534 8.83345 20.6239 6.97366C20.7777 6.8581 20.8012 6.65496 20.6766 6.51368C20.3888 6.18719 19.9596 6 19.4996 6H4.49963C4.03968 6 3.61046 6.18719 3.32263 6.51371C3.19811 6.65496 3.22156 6.8581 3.37537 6.97366Z",
    fill: "#FF8000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7825 7.98127C20.6496 7.92627 20.4932 7.94546 20.3826 8.02946C17.6429 10.094 14.1464 12.7403 13.0463 13.6215C12.4288 14.1169 11.5719 14.1169 10.953 13.6208C9.78038 12.6816 5.85384 9.7144 3.61741 8.02943C3.50607 7.94543 3.34935 7.9269 3.21751 7.98124C3.08497 8.03596 3 8.15381 3 8.28369V16.6668C3 17.4022 3.67271 18.0002 4.50001 18.0002H19.5C20.3273 18.0002 21 17.4022 21 16.6668V8.28369C21 8.15381 20.915 8.03565 20.7825 7.98127Z",
    fill: "#FF8000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.68794657bbc876b657555e30963aafb2.svg";
export { ForwardRef as ReactComponent };